export const adicionarVariavel = () => ({
    type: "ADICIONAR_VARIAVEL",
  });
  
  export const removerVariavel = (index) => ({
    type: "REMOVER_VARIAVEL",
    payload: index,
  });
  
  export const atualizarVariavel = (index, campo, valor) => ({
    type: "ATUALIZAR_VARIAVEL",
    payload: { index, campo, valor },
  });

  export const setVariaveis = (variaveis) => ({
    type: "SET_VARIAVEIS",
    payload: variaveis,
  });
  